import {TaillightBitmap} from './taillight-bitmap'
import {TaillightCSS} from './taillight-css-renderer'
import {taillightPlacementProperties, type TaillightProps} from './taillight-types'

const placementProperties = new Set<string>(taillightPlacementProperties)

/** Selects a renderer for one prepared block, keeping CSS and bitmap hooks isolated. */
export function Taillight(props: TaillightProps) {
  for (const property of Object.keys(props.style ?? {})) {
    if (!placementProperties.has(property)) {
      throw new Error(
        `Unsupported Taillight style property: ${property}. Use TaillightsProvider rendering for typography and padding.`,
      )
    }
  }
  if (props.renderer === 'css') return <TaillightCSS {...props} />
  return <TaillightBitmap {...props} />
}
